module.exports = __webpack_public_path__ + "static/widget-img-15-59e4545819355594ad7de420d3f0cbc6.png";